import { ContactsScreen } from "@src/features/contacts/screens/ContactsScreen";

export default function CameraActivityNotificationRoute() {
  return <ContactsScreen title="Activity Notification" category="activity" />;
}
